<template>
  <Form ref="form" :validation-schema="schema">
    <div class="candidature-group-sub">
      <h2>{{ label }}
        <span v-if="isRemovable===true" style="cursor:pointer; float: right" @click="$emit('callRemove', index)">
          <br/>
          <span class="candidature-button-content-label">Supprimer</span>
          <span class="candidature-button-icon"><img src="@/assets/img/minus.png" alt="Supprimer"/></span>
        </span>
      </h2>


      <div class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="yearExperience1">Année*</label>
        <Field :value="year" @input="$emit('update:year', $event)" as="select" class="form-control" name="year">
          <option disabled value=""></option>
          <option v-for="yearLabel in years" v-bind:key="yearLabel" :value="yearLabel">{{ yearLabel }}</option>
        </Field>
        <ErrorMessage class="error-feedback" name="year"/>
      </div>

      <div class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="nameExperience">Emploi occupé et nom de l'entreprise*</label>
        <Field :value="name" @input="$emit('update:name', $event)" class="form-control" name="name" placeholder="" type="text"/>
        <ErrorMessage class="error-feedback" name="name"/>
      </div>

      <div class="candidature-condition candidature-condition-col">
        <label class="candidature-condition-text" for="depExperience">Département de l'entreprise*</label>
        <Field :value="department" @input="$emit('update:department', $event)" class="form-control" name="department" placeholder="" type="text"/>
        <ErrorMessage class="error-feedback" name="department"/>
      </div>

      <div v-if="moduleType !=='Stage'" class="candidature-condition candidature-condition-col row">
        <label class="candidature-condition-text" for="typeExperience1">Type de contrat*</label>
        <Field :value="type" @input="$emit('update:type', $event)" as="select" class="form-control" name="type">
          <option disabled value=""></option>
          <option value="CDI">Contrat à durée indéterminée</option>
          <option value="CDD">Contrat à durée déterminée</option>
          <option value="Intérim">Intérim</option>
          <option value="CPro">Contrat de professionnalisation</option>
          <option value="Autre">Autre</option>
        </Field>
        <ErrorMessage class="error-feedback" name="type"/>
      </div>
      <div v-else>
        <Field :value="type" @input="$emit('update:type', $event)" class="form-control" name="type" placeholder="" type="text" v-show="false"/>
        <ErrorMessage class="error-feedback" name="type"/>
      </div>

      <div class="candidature-condition candidature-condition-col">
        <label class="candidature-condition-text" for="durationExperience1">Durée*</label>
        <Field :value="duration" @input="$emit('update:duration', $event)" as="select" class="form-control" name="duration">
          <option disabled value=""></option>
          <option value="1 semaine">1 semaine</option>
          <option value="2 semaines">2 semaines</option>
          <option value="3 semaines">3 semaines</option>
          <option value="1 mois">1 mois</option>
          <option value="2 mois">2 mois</option>
          <option value="3 à 6 mois">3 à 6 mois</option>
          <option value="6 à 9 mois">6 à 9 mois</option>
          <option value="9 à 12 mois">9 à 12 mois</option>
          <option value="1 an à 1 an 1/2">1 an à 1 an 1/2</option>
          <option value="1 an 1/2 à 2 ans">1 an 1/2 à 2 ans</option>
          <option value="2 ans à 2 ans 1/2">2 ans à 2 ans 1/2</option>
          <option value="2 ans 1/2 à 3 ans">2 ans 1/2 à 3 ans</option>
          <option value="3 à 4 ans">3 à 4 ans</option>
          <option value="4 à 5 ans">4 à 5 ans</option>
          <option value="5 à 6 ans">5 à 6 ans</option>
          <option value="6 à 7 ans">6 à 7 ans</option>
          <option value="7 à 8 ans">7 à 8 ans</option>
          <option value="8 à 10 ans">8 à 10 ans</option>
          <option value="10 à 12 ans">10 à 12 ans</option>
          <option value="12 à 14 ans">12 à 14 ans</option>
          <option value="14 à 17 ans">14 à 17 ans</option>
          <option value="17 à 20 ans">17 à 20 ans</option>
          <option value="20 à 25 ans">20 à 25 ans</option>
          <option value="25 à 30 ans">25 à 30 ans</option>

        </Field>
        <ErrorMessage class="error-feedback" name="duration"/>
      </div>

      <div v-if="moduleType ==='Stage'" class="candidature-condition candidature-condition-col row">
        <div class="candidature-group">
          <h1><img src="@/assets/img/underline.png" alt="PIÈCE JUSTIFICATIVE"> PIÈCE JUSTIFICATIVE </h1>

          <label :id="'trainingcheck-anchor'+index" class="candidature-condition" :for="'trainingCertificate'+index">
            <input :id="'trainingCertificate'+index" :name="'trainingCertificate'+index" accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png" class="candidature-input-file" type="file"
                   @change="fileChange($event.target.name, $event.target.files , 'training'+index);">
            <div class="candidature-button">
              <div class="candidature-button-content">
                <div>
                  <div v-if="fileCheck" class="candidature-button-icon"><img src="@/assets/img/check.png"></div>
                  <div v-else class="candidature-button-icon"><img src="@/assets/img/plus.png"></div>
                </div>
                <div class="candidature-button-content-label">Attestation stage d'immersion n°{{ index }}<br><a :id="'training' +index" :href="attestationUrl" target=”_blank”>{{ attestationName }}</a></div>
              </div>
            </div>
          </label>

          <Field id="fileCheck" ref="fileCheck" :value="fileCheck" @input="$emit('update:fileCheck', $event)" class="form-control" name="fileCheck" placeholder="" v-show="false" type="text"/>
          <ErrorMessage class="error-feedback" name="fileCheck"/>
        </div>

      </div>


    </div>


  </Form>

</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import {simulateNewfiles} from "@/services/fake-href.service";


export default {
  name: "Experience",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    index: {type: Number, required: true},
    label: {type: String, required: true},
    year: {type: [String, Number], default: null},
    name: {type: String, default: ""},
    department: {type: [String, Number], default: null},
    type: {type: String, default: ""},
    duration: {type: String, default: ""},
    moduleType: {type: String, required: true},
    removable: {type: Boolean, default: false},
    trainingcheck: Boolean,
    attestationName: String,
    attestationUrl: String,
    attestation: String,
  },
  emits: [
    'update:year',
    'update:name',
    'update:department',
    'update:type',
    'update:duration',
    'update:fileCheck',
    'callRemove'
  ],
  data() {
    return {
      fileCheck: this.trainingcheck,
      fileList: [],
      isRemovable: this.removable
    };
  },
  methods: {
    setRemovable(value) {
      if (true === value) {
        this.isRemovable = true;
        return;
      }
      this.isRemovable = false;
    },

    fileChange(fieldName, fileList, id) {
      if (!fileList.length) {
        return;
      }
      const allowedTypes = document.getElementById(fieldName).accept.split(',').map(type => `${type.trim()}`);
      if (!allowedTypes.includes(fileList[0].type)) {
        alert(`Le type de fichier n\'est pas autorisé`)
        return;
      }
      if (fileList[0]['size'] > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo')
        return;
      }
      simulateNewfiles(fileList[0], id);
      this.fileCheck = true;
      this.fileList = fileList;
      this.$emit('update:fileCheck', true);
    }

  },

  computed: {
    years: function () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 1950}, (value, index) => year - index)
    },
    schema() {
      return yup.object().shape({
        year: yup
            .string()
            .nullable()
            .required("Année : Ce champ doit être renseigné")
        ,
        name: yup
            .string()
            .required("Emploi : Ce champ doit être renseigné")
        ,
        department: yup
            .string()
            .nullable()
            .required("Département : Ce champ doit être renseigné")
        ,
        type: yup
            .string()
            .required("Type : Ce champ doit être renseigné")
        ,
        duration: yup
            .string()
            .required("Durée : Ce champ doit être renseigné")
        ,
        fileCheck: yup
            .string()
            .test(
                'file-check',
                "Attestation : Ce champ doit être renseigné",
                (value) => {
                  if (this.moduleType !== 'Stage') return true;
                  return value === 'true' || this.fileCheck === true || this.fileList.length > 0;
                }
            )
      })
    },

  }
}
</script>
